module.exports = __webpack_public_path__ + "static/media/strip-mobile-user-management-desk.ec50d8cc.png";